var items = {
  "block.minecraft.air": "aer",
  "block.minecraft.stone": "cloch",
  "block.minecraft.granite": "eibhear",
  "block.minecraft.polished_granite": "eibhear snasta",
  "block.minecraft.diorite": "dióirít",
  "block.minecraft.polished_diorite": "dióirít shnasta",
  "block.minecraft.andesite": "aindéisít",
  "block.minecraft.polished_andesite": "aindéisít shnasta",
  "block.minecraft.grass_block": "bloc féir",
  "block.minecraft.dirt": "ithir",
  "block.minecraft.coarse_dirt": "garbhithir",
  "block.minecraft.podzol": "podsol",
  "block.minecraft.crimson_nylium": "íoscaeiliam craorag",
  "block.minecraft.warped_nylium": "íoscaeiliam saofa",
  "block.minecraft.cobblestone": "doirneog",
  "block.minecraft.oak_planks": "cláir darach",
  "block.minecraft.spruce_planks": "cláir sprúis",
  "block.minecraft.birch_planks": "cláir beithe",
  "block.minecraft.jungle_planks": "clár adhmad dufaire",
  "block.minecraft.acacia_planks": "cláir acáise",
  "block.minecraft.dark_oak_planks": "cláir dharach duibhe",
  "block.minecraft.crimson_planks": "cláir chraoraga",
  "block.minecraft.warped_planks": "cláir shaofa",
  "block.minecraft.oak_sapling": "dair óg",
  "block.minecraft.spruce_sapling": "sprús óg",
  "block.minecraft.birch_sapling": "beith óg",
  "block.minecraft.jungle_sapling": "crann dufaire óg",
  "block.minecraft.acacia_sapling": "acaicia óg",
  "block.minecraft.dark_oak_sapling": "dair dhubh óg",
  "block.minecraft.bedrock": "buncharraig",
  "block.minecraft.sand": "gaineamh",
  "block.minecraft.red_sand": "gaineamh dearg",
  "block.minecraft.gravel": "gairbhéal",
  "block.minecraft.gold_ore": "mian óir",
  "block.minecraft.iron_ore": "amhiarann",
  "block.minecraft.coal_ore": "mian guail",
  "block.minecraft.nether_gold_ore": "méine óir nether",
  "block.minecraft.oak_log": "ceap darach",
  "block.minecraft.spruce_log": "ceap sprúis",
  "block.minecraft.birch_log": "ceap beithe",
  "block.minecraft.jungle_log": "stoc dufaire",
  "block.minecraft.acacia_log": "ceap acáise",
  "block.minecraft.dark_oak_log": "ceap darach duibhe",
  "block.minecraft.crimson_stem": "gas craorag",
  "block.minecraft.warped_stem": "gas saofa",
  "block.minecraft.stripped_oak_log": "lomán darach",
  "block.minecraft.stripped_spruce_log": "lomán sprúis",
  "block.minecraft.stripped_birch_log": "lomán beithe",
  "block.minecraft.stripped_jungle_log": "lomán dufaire",
  "block.minecraft.stripped_acacia_log": "lomán acáise",
  "block.minecraft.stripped_dark_oak_log": "lomán darach duibhe",
  "block.minecraft.stripped_crimson_stem": "gas craorag scafa",
  "block.minecraft.stripped_warped_stem": "gas saofa scafa",
  "block.minecraft.stripped_oak_wood": "lomán darach meilte",
  "block.minecraft.stripped_spruce_wood": "lomán sprúis meilte",
  "block.minecraft.stripped_birch_wood": "lomán beithe meilte",
  "block.minecraft.stripped_jungle_wood": "adhmad scafa dufaire",
  "block.minecraft.stripped_acacia_wood": "lomán acáise meilte",
  "block.minecraft.stripped_dark_oak_wood": "lomán darach duibhe meilte",
  "block.minecraft.stripped_crimson_hyphae": "hífí craoraga scafa",
  "block.minecraft.stripped_warped_hyphae": "hífí saofa scafa",
  "block.minecraft.oak_wood": "adhmad darach",
  "block.minecraft.spruce_wood": "adhmad sprúis",
  "block.minecraft.birch_wood": "adhmad beithe",
  "block.minecraft.jungle_wood": "adhmad dufaire",
  "block.minecraft.acacia_wood": "adhmad acaicia",
  "block.minecraft.dark_oak_wood": "adhmad darach duibhe",
  "block.minecraft.crimson_hyphae": "hífí craoraga",
  "block.minecraft.warped_hyphae": "hífí saofa",
  "block.minecraft.oak_leaves": "duilleoga darach",
  "block.minecraft.spruce_leaves": "duilleoga sprúis",
  "block.minecraft.birch_leaves": "duilleoga beithe",
  "block.minecraft.jungle_leaves": "duilleoga dufaire",
  "block.minecraft.acacia_leaves": "duilleoga acaicia",
  "block.minecraft.dark_oak_leaves": "duilleoga darach duibhe",
  "block.minecraft.sponge": "spúinse",
  "block.minecraft.wet_sponge": "spúinse fliuch",
  "block.minecraft.glass": "gloine",
  "block.minecraft.lapis_ore": "mian lapis lazuli",
  "block.minecraft.lapis_block": "bloc lapis lazuli",
  "block.minecraft.dispenser": "teilgeoir",
  "block.minecraft.sandstone": "gaineamhchloch",
  "block.minecraft.chiseled_sandstone": "gaineamhchloch shiséalta",
  "block.minecraft.cut_sandstone": "gaineamhchloch gearrtha",
  "block.minecraft.note_block": "bloc nóta",
  "block.minecraft.powered_rail": "ráillí cumhachtaithe",
  "block.minecraft.detector_rail": "ráillí brathadóireachta",
  "block.minecraft.sticky_piston": "loine greamaitheach",
  "block.minecraft.cobweb": "gréasán an damháin alla",
  "block.minecraft.grass": "féar",
  "block.minecraft.fern": "raithneach",
  "block.minecraft.dead_bush": "tor marbh",
  "block.minecraft.seagrass": "féar mara",
  "block.minecraft.sea_pickle": "picil mara",
  "block.minecraft.piston": "loine",
  "block.minecraft.white_wool": "olann bhán",
  "block.minecraft.orange_wool": "olann oráisteach",
  "block.minecraft.magenta_wool": "olann mhaigeanta",
  "block.minecraft.light_blue_wool": "olann bhánghorm",
  "block.minecraft.yellow_wool": "olann bhuí",
  "block.minecraft.lime_wool": "olann líomach",
  "block.minecraft.pink_wool": "olann bhándearg",
  "block.minecraft.gray_wool": "olann liath",
  "block.minecraft.light_gray_wool": "olann fhionnliath",
  "block.minecraft.cyan_wool": "olann chian",
  "block.minecraft.purple_wool": "olann chorcra",
  "block.minecraft.blue_wool": "olann ghorm",
  "block.minecraft.brown_wool": "olann dhonn",
  "block.minecraft.green_wool": "olann uaine",
  "block.minecraft.red_wool": "olann dhearg",
  "block.minecraft.black_wool": "olann dhubh",
  "block.minecraft.dandelion": "caisearbhán",
  "block.minecraft.poppy": "poipín",
  "block.minecraft.blue_orchid": "magairlín gorm",
  "block.minecraft.allium": "allium",
  "block.minecraft.azure_bluet": "goirmín spéiriúil",
  "block.minecraft.red_tulip": "tiúilip dhearg",
  "block.minecraft.orange_tulip": "tiúilip oráisteach",
  "block.minecraft.white_tulip": "tiúilip bhán",
  "block.minecraft.pink_tulip": "tiúilip bhándearg",
  "block.minecraft.oxeye_daisy": "nóinín mór",
  "block.minecraft.cornflower": "gormán",
  "block.minecraft.lily_of_the_valley": "lile na ngleanntán",
  "block.minecraft.wither_rose": "rós wither",
  "block.minecraft.brown_mushroom": "beacán donn",
  "block.minecraft.red_mushroom": "beacán dearg",
  "block.minecraft.crimson_fungus": "fungas craorag",
  "block.minecraft.warped_fungus": "fungas saofa",
  "block.minecraft.crimson_roots": "fréamhach craorag",
  "block.minecraft.warped_roots": "fréamhach saofa",
  "block.minecraft.nether_sprouts": "péacáin íochtair",
  "block.minecraft.weeping_vines": "féithleog shilte",
  "block.minecraft.twisting_vines": "féithleog lúbach",
  "block.minecraft.sugar_cane": "cána siúcra",
  "block.minecraft.kelp": "ceilp",
  "block.minecraft.bamboo": "bambú",
  "block.minecraft.gold_block": "bloc óir",
  "block.minecraft.iron_block": "bloc iarainn",
  "block.minecraft.oak_slab": "leac dharach",
  "block.minecraft.spruce_slab": "leac sprúis",
  "block.minecraft.birch_slab": "leac bheithe",
  "block.minecraft.jungle_slab": "leac chapóic",
  "block.minecraft.acacia_slab": "leac acáise",
  "block.minecraft.dark_oak_slab": "leac dharach duibhe",
  "block.minecraft.crimson_slab": "leac chraorag",
  "block.minecraft.warped_slab": "leac shaofa",
  "block.minecraft.stone_slab": "leac chloiche",
  "block.minecraft.smooth_stone_slab": "leac cloiche míne",
  "block.minecraft.sandstone_slab": "leac ghaineamhchloiche",
  "block.minecraft.cut_sandstone_slab": "leac ghaineamhchloiche gearrtha",
  "block.minecraft.petrified_oak_slab": "leac dharach clochraithe",
  "block.minecraft.cobblestone_slab": "leac dhoirneoige",
  "block.minecraft.brick_slab": "leac bhríce",
  "block.minecraft.stone_brick_slab": "leac bhríce cloiche",
  "block.minecraft.nether_brick_slab": "leac íochtarbhríce",
  "block.minecraft.quartz_slab": "leac ghrianchloiche",
  "block.minecraft.red_sandstone_slab": "leac ghaineamhchloiche deirge",
  "block.minecraft.cut_red_sandstone_slab": "leac ghaineamhchloiche gearrtha deirge",
  "block.minecraft.purpur_slab": "leac purpaire",
  "block.minecraft.prismarine_slab": "leac priosmuirínigh",
  "block.minecraft.prismarine_brick_slab": "leac bríce priosmuiríní",
  "block.minecraft.dark_prismarine_slab": "leac dhúphriosmuirín",
  "block.minecraft.smooth_quartz": "bloc grianchloiche míne",
  "block.minecraft.smooth_red_sandstone": "gaineamhchloch dhearg mhín",
  "block.minecraft.smooth_sandstone": "gaineamhchloch mhín",
  "block.minecraft.smooth_stone": "cloch mhín",
  "block.minecraft.bricks": "brící",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "seilf leabhar",
  "block.minecraft.mossy_cobblestone": "doirneog chaonaigh",
  "block.minecraft.obsidian": "obsaidian",
  "block.minecraft.torch": "tóirse",
  "block.minecraft.end_rod": "slat na críche",
  "block.minecraft.chorus_plant": "planda chorus",
  "block.minecraft.chorus_flower": "bláth chorus",
  "block.minecraft.purpur_block": "bloc purpaire",
  "block.minecraft.purpur_pillar": "colún purpaire",
  "block.minecraft.purpur_stairs": "staighre purpaire",
  "block.minecraft.spawner": "gineadóir",
  "block.minecraft.oak_stairs": "staighre darach",
  "block.minecraft.chest": "cófra",
  "block.minecraft.diamond_ore": "mian diamaint",
  "block.minecraft.diamond_block": "bloc diamaint",
  "block.minecraft.crafting_table": "bord ceardaíochta",
  "block.minecraft.farmland": "talamh feirme",
  "block.minecraft.furnace": "foirnéis",
  "block.minecraft.ladder": "dréimire",
  "block.minecraft.rail": "ráillí",
  "block.minecraft.cobblestone_stairs": "staighre doirneoige",
  "block.minecraft.lever": "luamhán",
  "block.minecraft.stone_pressure_plate": "brúphláta cloiche",
  "block.minecraft.oak_pressure_plate": "brúphláta darach",
  "block.minecraft.spruce_pressure_plate": "brúphláta sprúis",
  "block.minecraft.birch_pressure_plate": "brúphláta beithe",
  "block.minecraft.jungle_pressure_plate": "brúphláta dufaire",
  "block.minecraft.acacia_pressure_plate": "brúphláta acáise",
  "block.minecraft.dark_oak_pressure_plate": "brúphláta darach duibhe",
  "block.minecraft.crimson_pressure_plate": "brúphláta craorag",
  "block.minecraft.warped_pressure_plate": "brúphláta saofa",
  "block.minecraft.polished_blackstone_pressure_plate": "brúphláta dúchloiche snasta",
  "block.minecraft.redstone_ore": "mian deargchloiche",
  "block.minecraft.redstone_torch": "tóirse deargchloiche",
  "block.minecraft.snow": "sneachta",
  "block.minecraft.ice": "oighear",
  "block.minecraft.snow_block": "bloc sneachta",
  "block.minecraft.cactus": "cachtas",
  "block.minecraft.clay": "cré",
  "block.minecraft.jukebox": "júcbhosca",
  "block.minecraft.oak_fence": "claí darach",
  "block.minecraft.spruce_fence": "claí sprúis",
  "block.minecraft.birch_fence": "claí beithe",
  "block.minecraft.jungle_fence": "claí dufaire",
  "block.minecraft.acacia_fence": "claí acaicia",
  "block.minecraft.dark_oak_fence": "claí darach duibhe",
  "block.minecraft.crimson_fence": "claí craorag",
  "block.minecraft.warped_fence": "claí saofa",
  "block.minecraft.pumpkin": "puimcín",
  "block.minecraft.carved_pumpkin": "puimcín snoite",
  "block.minecraft.netherrack": "íochtarchloch",
  "block.minecraft.soul_sand": "gaineamh anama",
  "block.minecraft.soul_soil": "ithir spride",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "basalt snasta",
  "block.minecraft.soul_torch": "tóirse spride",
  "block.minecraft.glowstone": "lonnraít",
  "block.minecraft.jack_o_lantern": "seán na gealaí",
  "block.minecraft.oak_trapdoor": "comhla darach",
  "block.minecraft.spruce_trapdoor": "comhla sprúis",
  "block.minecraft.birch_trapdoor": "comhla beithe",
  "block.minecraft.jungle_trapdoor": "comhla dufaire",
  "block.minecraft.acacia_trapdoor": "comhla acáise",
  "block.minecraft.dark_oak_trapdoor": "comhla darach duibhe",
  "block.minecraft.crimson_trapdoor": "comhla chraorag",
  "block.minecraft.warped_trapdoor": "comhla shaofa",
  "block.minecraft.infested_stone": "cloch fhoirgthe",
  "block.minecraft.infested_cobblestone": "doirneog fhoirgthe",
  "block.minecraft.infested_stone_bricks": "brící cloiche foirgthe",
  "block.minecraft.infested_mossy_stone_bricks": "brící cloiche caonaigh foirgthe",
  "block.minecraft.infested_cracked_stone_bricks": "brící cloiche scoilte foirgthe",
  "block.minecraft.infested_chiseled_stone_bricks": "brící cloiche siséalta foirgthe",
  "block.minecraft.stone_bricks": "brící cloiche",
  "block.minecraft.mossy_stone_bricks": "brící cloiche caonaigh",
  "block.minecraft.cracked_stone_bricks": "brící cloiche scoilte",
  "block.minecraft.chiseled_stone_bricks": "brící cloiche siséalta",
  "block.minecraft.brown_mushroom_block": "bloic beacáin dhoinn",
  "block.minecraft.red_mushroom_block": "bloc beacáin dheirg",
  "block.minecraft.mushroom_stem": "gas beacáin",
  "block.minecraft.iron_bars": "barraí iarainn",
  "block.minecraft.chain": "slabhrach",
  "block.minecraft.glass_pane": "pána gloine",
  "block.minecraft.melon": "mealbhacán",
  "block.minecraft.vine": "féithleog",
  "block.minecraft.oak_fence_gate": "geata darach",
  "block.minecraft.spruce_fence_gate": "geata sprúis",
  "block.minecraft.birch_fence_gate": "geata beithe",
  "block.minecraft.jungle_fence_gate": "geata dufaire",
  "block.minecraft.acacia_fence_gate": "géata acaicia",
  "block.minecraft.dark_oak_fence_gate": "geata darach duibhe",
  "block.minecraft.crimson_fence_gate": "geata craorag",
  "block.minecraft.warped_fence_gate": "geata saofa",
  "block.minecraft.brick_stairs": "staighre bríce",
  "block.minecraft.stone_brick_stairs": "staighre bhríce cloiche",
  "block.minecraft.mycelium": "mícéiliam",
  "block.minecraft.lily_pad": "duilleog bháite",
  "block.minecraft.nether_bricks": "íochtarbhrící",
  "block.minecraft.cracked_nether_bricks": "íochtarbhrící scoilte",
  "block.minecraft.chiseled_nether_bricks": "íochtarbhrící siséalta",
  "block.minecraft.nether_brick_fence": "claí íochtarbhríce",
  "block.minecraft.nether_brick_stairs": "staighre íochtarbhríce",
  "block.minecraft.enchanting_table": "bord asarlaíochta",
  "block.minecraft.end_portal_frame": "fráma tairsí na críche",
  "block.minecraft.end_stone": "cloch na críche",
  "block.minecraft.end_stone_bricks": "brící chloch na críche",
  "block.minecraft.dragon_egg": "ubh dhragain",
  "block.minecraft.redstone_lamp": "lampa deargchloiche",
  "block.minecraft.sandstone_stairs": "staighre gaineamhchloiche",
  "block.minecraft.emerald_ore": "mian smaragaide",
  "block.minecraft.ender_chest": "cófra na críche",
  "block.minecraft.tripwire_hook": "crúca shreang tuisle",
  "block.minecraft.emerald_block": "bloc smaragaide",
  "block.minecraft.spruce_stairs": "staighre sprúis",
  "block.minecraft.birch_stairs": "staighre beithe",
  "block.minecraft.jungle_stairs": "staighre dufaire",
  "block.minecraft.crimson_stairs": "staighre craorag",
  "block.minecraft.warped_stairs": "staighre saofa",
  "block.minecraft.command_block": "bloc ordaithe",
  "block.minecraft.beacon": "rabhcán",
  "block.minecraft.cobblestone_wall": "balla doirneoige",
  "block.minecraft.mossy_cobblestone_wall": "balla doirneoige caonaigh",
  "block.minecraft.brick_wall": "balla brící",
  "block.minecraft.prismarine_wall": "balla priosmuirín",
  "block.minecraft.red_sandstone_wall": "balla gaineamhchloiche deirge",
  "block.minecraft.mossy_stone_brick_wall": "balla brící cloiche caonaigh",
  "block.minecraft.granite_wall": "balla eibhir",
  "block.minecraft.stone_brick_wall": "balla brící cloiche",
  "block.minecraft.nether_brick_wall": "balla brící ifrinn",
  "block.minecraft.andesite_wall": "balla aindéisíte",
  "block.minecraft.red_nether_brick_wall": "balla brící dearga ifrinn",
  "block.minecraft.sandstone_wall": "balla gaineamhchloiche",
  "block.minecraft.end_stone_brick_wall": "balla brící cloiche an deireadh",
  "block.minecraft.diorite_wall": "balla dióiríte",
  "block.minecraft.blackstone_wall": "balla dúchloiche",
  "block.minecraft.polished_blackstone_wall": "balla dúchloiche snasta",
  "block.minecraft.polished_blackstone_brick_wall": "balla de bhrící dúchloiche snasta",
  "block.minecraft.stone_button": "cnaipe cloiche",
  "block.minecraft.oak_button": "cnaipe darach",
  "block.minecraft.spruce_button": "cnaipe sprúis",
  "block.minecraft.birch_button": "cnaipe beithe",
  "block.minecraft.jungle_button": "cnaipe dufaire",
  "block.minecraft.acacia_button": "cnaipe acáise",
  "block.minecraft.dark_oak_button": "cnaipe darach duibhe",
  "block.minecraft.crimson_button": "cnaipe craorag",
  "block.minecraft.warped_button": "cnaipe saofa",
  "block.minecraft.polished_blackstone_button": "cnaipe dúchloiche snasta",
  "block.minecraft.anvil": "inneoin",
  "block.minecraft.chipped_anvil": "inneoin scealptha",
  "block.minecraft.damaged_anvil": "inneoin damáistithe",
  "block.minecraft.trapped_chest": "cófra gaiste",
  "block.minecraft.light_weighted_pressure_plate": "brúphláta éadrom",
  "block.minecraft.heavy_weighted_pressure_plate": "brúphláta trom",
  "block.minecraft.daylight_detector": "brathadóir sholas lae",
  "block.minecraft.redstone_block": "bloc deargchloiche",
  "block.minecraft.nether_quartz_ore": "mian ghrianchloch an íochtair",
  "block.minecraft.hopper": "crannóg",
  "block.minecraft.chiseled_quartz_block": "bloc grianchloiche siséalta",
  "block.minecraft.quartz_block": "bloc grianchloiche",
  "block.minecraft.quartz_bricks": "brící ghrianchloiche",
  "block.minecraft.quartz_pillar": "colún grianchloiche",
  "block.minecraft.quartz_stairs": "staighre grianchloiche",
  "block.minecraft.activator_rail": "ráille gnímh",
  "block.minecraft.dropper": "dáileoir",
  "block.minecraft.white_terracotta": "cré bhruite bhán",
  "block.minecraft.orange_terracotta": "cré bhruite oráisteach",
  "block.minecraft.magenta_terracotta": "cré bhruite mhaigeanta",
  "block.minecraft.light_blue_terracotta": "cré bhruite bhánghorm",
  "block.minecraft.yellow_terracotta": "cré bhruite bhuí",
  "block.minecraft.lime_terracotta": "cré bhruite líomach",
  "block.minecraft.pink_terracotta": "cré bhruite bhándearg",
  "block.minecraft.gray_terracotta": "cré bhruite liath",
  "block.minecraft.light_gray_terracotta": "cré bhruite fhionnliath",
  "block.minecraft.cyan_terracotta": "cré bhruite ghorm",
  "block.minecraft.purple_terracotta": "cré bhruite chorcra",
  "block.minecraft.blue_terracotta": "cré bhruite liath",
  "block.minecraft.brown_terracotta": "cré bhruite dhonn",
  "block.minecraft.green_terracotta": "cré bhruite uaine",
  "block.minecraft.red_terracotta": "cré bhruite dhearg",
  "block.minecraft.black_terracotta": "cré bhruite dhubh",
  "block.minecraft.barrier": "bac",
  "block.minecraft.iron_trapdoor": "comhla thógála iarainn",
  "block.minecraft.hay_block": "burla féir",
  "block.minecraft.white_carpet": "cairpéad bán",
  "block.minecraft.orange_carpet": "cairpéad oráisteach",
  "block.minecraft.magenta_carpet": "cairpéad maigeanta",
  "block.minecraft.light_blue_carpet": "cairpéad bánghorm",
  "block.minecraft.yellow_carpet": "cairpéad buí",
  "block.minecraft.lime_carpet": "cairpéad líomach",
  "block.minecraft.pink_carpet": "cairpéad bándearg",
  "block.minecraft.gray_carpet": "cairpéad liath",
  "block.minecraft.light_gray_carpet": "cairpéad fionnliath",
  "block.minecraft.cyan_carpet": "cairpéad cian",
  "block.minecraft.purple_carpet": "cairpéad corcra",
  "block.minecraft.blue_carpet": "cairpéad gorm",
  "block.minecraft.brown_carpet": "cairpéad donn",
  "block.minecraft.green_carpet": "cairpéad uaine",
  "block.minecraft.red_carpet": "cairpéad dearg",
  "block.minecraft.black_carpet": "cairpéad dubh",
  "block.minecraft.terracotta": "cré bhruite",
  "block.minecraft.coal_block": "bloc guail",
  "block.minecraft.packed_ice": "dlúthoighear",
  "block.minecraft.acacia_stairs": "staighre acáise",
  "block.minecraft.dark_oak_stairs": "staighre darach duibhe",
  "block.minecraft.slime_block": "bloc glae",
  "block.minecraft.grass_path": "cosán féir",
  "block.minecraft.sunflower": "lus na gréine",
  "block.minecraft.lilac": "líológ",
  "block.minecraft.rose_bush": "rós tomach",
  "block.minecraft.peony": "piaine",
  "block.minecraft.tall_grass": "féar ard",
  "block.minecraft.large_fern": "raithneach mhór",
  "block.minecraft.white_stained_glass": "gloine bhán",
  "block.minecraft.orange_stained_glass": "gloine fhionnbhuí",
  "block.minecraft.magenta_stained_glass": "gloine mhaigeanta",
  "block.minecraft.light_blue_stained_glass": "gloine bhánghorm",
  "block.minecraft.yellow_stained_glass": "gloine bhuí",
  "block.minecraft.lime_stained_glass": "gloine líomach",
  "block.minecraft.pink_stained_glass": "gloine bhándearg",
  "block.minecraft.gray_stained_glass": "gloine liath",
  "block.minecraft.light_gray_stained_glass": "gloine fhionnliath",
  "block.minecraft.cyan_stained_glass": "gloine chian",
  "block.minecraft.purple_stained_glass": "gloine chorcra",
  "block.minecraft.blue_stained_glass": "gloine ghorm",
  "block.minecraft.brown_stained_glass": "gloine dhonn",
  "block.minecraft.green_stained_glass": "gloine uaine",
  "block.minecraft.red_stained_glass": "gloine dhearg",
  "block.minecraft.black_stained_glass": "gloine dhaite dhubh",
  "block.minecraft.white_stained_glass_pane": "pána bán",
  "block.minecraft.orange_stained_glass_pane": "pána flannbhuí",
  "block.minecraft.magenta_stained_glass_pane": "pána mageanta",
  "block.minecraft.light_blue_stained_glass_pane": "pána bánghorm",
  "block.minecraft.yellow_stained_glass_pane": "pána buí",
  "block.minecraft.lime_stained_glass_pane": "pána líomach",
  "block.minecraft.pink_stained_glass_pane": "pána bándearg",
  "block.minecraft.gray_stained_glass_pane": "pána liath",
  "block.minecraft.light_gray_stained_glass_pane": "pána fionnliath",
  "block.minecraft.cyan_stained_glass_pane": "pána cian",
  "block.minecraft.purple_stained_glass_pane": "pána corcra",
  "block.minecraft.blue_stained_glass_pane": "pána gorm",
  "block.minecraft.brown_stained_glass_pane": "pána donn",
  "block.minecraft.green_stained_glass_pane": "pána glas",
  "block.minecraft.red_stained_glass_pane": "pána dearg",
  "block.minecraft.black_stained_glass_pane": "pána dubh",
  "block.minecraft.prismarine": "priosmuiríneach",
  "block.minecraft.prismarine_bricks": "brící priosmuirínigh",
  "block.minecraft.dark_prismarine": "priosmuiríneach dubh",
  "block.minecraft.prismarine_stairs": "staighre priosmuirínigh",
  "block.minecraft.prismarine_brick_stairs": "staighre bríce priosmuiríní",
  "block.minecraft.dark_prismarine_stairs": "staighre priosmuirínigh dhuibh",
  "block.minecraft.sea_lantern": "laindéar farraige",
  "block.minecraft.red_sandstone": "gaineamhchloch dhearg",
  "block.minecraft.chiseled_red_sandstone": "gaineamhchloch dhearg shiséalta",
  "block.minecraft.cut_red_sandstone": "gaineamhchloch dearg ghearrtha",
  "block.minecraft.red_sandstone_stairs": "staighre gaineamhchloiche deirge",
  "block.minecraft.repeating_command_block": "bloc ordaithe athfhillteach",
  "block.minecraft.chain_command_block": "bloc ordaithe slabhrach",
  "block.minecraft.magma_block": "bloc magma",
  "block.minecraft.nether_wart_block": "bloc mhus an íochtair",
  "block.minecraft.warped_wart_block": "bloc musa shaofa",
  "block.minecraft.red_nether_bricks": "íochtarbhrící dearga",
  "block.minecraft.bone_block": "bloc cnáimhe",
  "block.minecraft.structure_void": "folús struchtúrach",
  "block.minecraft.observer": "breathnóir",
  "block.minecraft.shulker_box": "bosca mollcaire",
  "block.minecraft.white_shulker_box": "bosca mollcaire bán",
  "block.minecraft.orange_shulker_box": "bosca mollcaire flannbhuí",
  "block.minecraft.magenta_shulker_box": "bosca mollcaire maigeanta",
  "block.minecraft.light_blue_shulker_box": "bosca mollcaire bánghorm",
  "block.minecraft.yellow_shulker_box": "bosca mollcaire buí",
  "block.minecraft.lime_shulker_box": "bosca mollcaire líomach",
  "block.minecraft.pink_shulker_box": "bosca mollcaire bándearg",
  "block.minecraft.gray_shulker_box": "bosca mollcaire liath",
  "block.minecraft.light_gray_shulker_box": "bosca mollcaire fionnliath",
  "block.minecraft.cyan_shulker_box": "bosca mollcaire cian",
  "block.minecraft.purple_shulker_box": "bosca slíogadóra corcra",
  "block.minecraft.blue_shulker_box": "bosca mollcaire gorm",
  "block.minecraft.brown_shulker_box": "bosca mollcaire donn",
  "block.minecraft.green_shulker_box": "bosca slíogadóra uaine",
  "block.minecraft.red_shulker_box": "bosca mollcaire dearg",
  "block.minecraft.black_shulker_box": "bosca mollcaire dubh",
  "block.minecraft.white_glazed_terracotta": "cré ghlónraithe bhán",
  "block.minecraft.orange_glazed_terracotta": "cré ghlónraithe oráisteach",
  "block.minecraft.magenta_glazed_terracotta": "cré ghlónraithe mhaigeanta",
  "block.minecraft.light_blue_glazed_terracotta": "cré ghlónraithe bhánghorm",
  "block.minecraft.yellow_glazed_terracotta": "cré ghlónraithe bhuí",
  "block.minecraft.lime_glazed_terracotta": "cré ghlónraithe líomach",
  "block.minecraft.pink_glazed_terracotta": "cré ghlónraithe bhándearg",
  "block.minecraft.gray_glazed_terracotta": "cré ghlónraithe liath",
  "block.minecraft.light_gray_glazed_terracotta": "cré ghlónraithe fhionnliath",
  "block.minecraft.cyan_glazed_terracotta": "cré ghlónraithe chian",
  "block.minecraft.purple_glazed_terracotta": "cré ghlónraithe chorcra",
  "block.minecraft.blue_glazed_terracotta": "cré ghlónraithe ghorm",
  "block.minecraft.brown_glazed_terracotta": "cré ghlónraithe dhonn",
  "block.minecraft.green_glazed_terracotta": "cré ghlónraithe uaine",
  "block.minecraft.red_glazed_terracotta": "cré ghlónraithe dhearg",
  "block.minecraft.black_glazed_terracotta": "cré ghlónraithe dhubh",
  "block.minecraft.white_concrete": "coincréit bhán",
  "block.minecraft.orange_concrete": "coincréit oráisteach",
  "block.minecraft.magenta_concrete": "coincréit mhaigeanta",
  "block.minecraft.light_blue_concrete": "stroighin bhánghorm",
  "block.minecraft.yellow_concrete": "coincréit bhuí",
  "block.minecraft.lime_concrete": "coincréit líomach",
  "block.minecraft.pink_concrete": "coincréit bhándearg",
  "block.minecraft.gray_concrete": "coincréit liath",
  "block.minecraft.light_gray_concrete": "coincréit fhionnliath",
  "block.minecraft.cyan_concrete": "coincréit chian",
  "block.minecraft.purple_concrete": "coincréit chorcra",
  "block.minecraft.blue_concrete": "coincréit ghorm",
  "block.minecraft.brown_concrete": "stroighin dhonn",
  "block.minecraft.green_concrete": "coincréit uaine",
  "block.minecraft.red_concrete": "coincréit dhearg",
  "block.minecraft.black_concrete": "coincréit dhubh",
  "block.minecraft.white_concrete_powder": "púdar coincréite bán",
  "block.minecraft.orange_concrete_powder": "púdar coincréite flannbhuí",
  "block.minecraft.magenta_concrete_powder": "púdar coincréite maigeanta",
  "block.minecraft.light_blue_concrete_powder": "púdar coincréite bánghorm",
  "block.minecraft.yellow_concrete_powder": "púdar coincréite buí",
  "block.minecraft.lime_concrete_powder": "púdar coincréite líomach",
  "block.minecraft.pink_concrete_powder": "púdar coincréite bándearg",
  "block.minecraft.gray_concrete_powder": "púdar coincréite liath",
  "block.minecraft.light_gray_concrete_powder": "púdar coincréite fionnliath",
  "block.minecraft.cyan_concrete_powder": "púdar coincréite cian",
  "block.minecraft.purple_concrete_powder": "púdar coincréite corcra",
  "block.minecraft.blue_concrete_powder": "púdar coincréite gorm",
  "block.minecraft.brown_concrete_powder": "púdar coincréite donn",
  "block.minecraft.green_concrete_powder": "púdar coincréite uaine",
  "block.minecraft.red_concrete_powder": "púdar coincréite dearg",
  "block.minecraft.black_concrete_powder": "púdar coincréite dubh",
  "block.minecraft.turtle_egg": "ubh thurtair",
  "block.minecraft.dead_tube_coral_block": "bloc tiúbchoiréil mhairbh",
  "block.minecraft.dead_brain_coral_block": "bloc inchinnchoiréil mhairbh",
  "block.minecraft.dead_bubble_coral_block": "bloc bolgánchoiréil mhairbh",
  "block.minecraft.dead_fire_coral_block": "bloc tinechoiréil mhairbh",
  "block.minecraft.dead_horn_coral_block": "bloc adharc-choiréil mhairbh",
  "block.minecraft.tube_coral_block": "bloc tiúbchoiréil",
  "block.minecraft.brain_coral_block": "bloc inchinnchoiréil",
  "block.minecraft.bubble_coral_block": "bloc bolgánchoiréil",
  "block.minecraft.fire_coral_block": "bloc tinechoiréil",
  "block.minecraft.horn_coral_block": "bloc adharc-choiréil",
  "block.minecraft.tube_coral": "tiúbchoiréal",
  "block.minecraft.brain_coral": "inchinnchoiréal",
  "block.minecraft.bubble_coral": "bolgánchoiréal",
  "block.minecraft.fire_coral": "tinechoiréal",
  "block.minecraft.horn_coral": "adharc-choiréal",
  "block.minecraft.dead_brain_coral": "inchinnchoiréal marbh",
  "block.minecraft.dead_bubble_coral": "bolgánchoiréal marbh",
  "block.minecraft.dead_fire_coral": "tinechoiréal marbh",
  "block.minecraft.dead_horn_coral": "adharc-choiréal marbh",
  "block.minecraft.dead_tube_coral": "tiúbchoiréil marbh",
  "block.minecraft.tube_coral_fan": "fean tiúbchoiréil",
  "block.minecraft.brain_coral_fan": "fean inchinnchoiréil",
  "block.minecraft.bubble_coral_fan": "fean bolgánchoiréil",
  "block.minecraft.fire_coral_fan": "fean tinechoiréil",
  "block.minecraft.horn_coral_fan": "fean adharc-choiréil",
  "block.minecraft.dead_tube_coral_fan": "fean tiúbhchoiréil mhairbh",
  "block.minecraft.dead_brain_coral_fan": "fean inchinnchoiréil mhairbh",
  "block.minecraft.dead_bubble_coral_fan": "fean bolgánchoiréil mhairbh",
  "block.minecraft.dead_fire_coral_fan": "fean tinechoiréil mhairbh",
  "block.minecraft.dead_horn_coral_fan": "fean adharc-choiréil mhairbh",
  "block.minecraft.blue_ice": "oighear gorm",
  "block.minecraft.conduit": "seolphíopa",
  "block.minecraft.polished_granite_stairs": "staighre eibhir shnasta",
  "block.minecraft.smooth_red_sandstone_stairs": "staighre gaineamhchloiche deirge míne",
  "block.minecraft.mossy_stone_brick_stairs": "staighre brící cloiche caonaigh",
  "block.minecraft.polished_diorite_stairs": "staighre dióiríte snasta",
  "block.minecraft.mossy_cobblestone_stairs": "staighre doirneoige caonaigh",
  "block.minecraft.end_stone_brick_stairs": "staighre brící cloiche an deiridh",
  "block.minecraft.stone_stairs": "staighre cloiche",
  "block.minecraft.smooth_sandstone_stairs": "staighre gaineamhchloiche míne",
  "block.minecraft.smooth_quartz_stairs": "staighre grianchloiche míne",
  "block.minecraft.granite_stairs": "staighre eibhir",
  "block.minecraft.andesite_stairs": "staighre aindéisíte",
  "block.minecraft.red_nether_brick_stairs": "staighre brící dearga ifrinn",
  "block.minecraft.polished_andesite_stairs": "staighre andéisíte snasta",
  "block.minecraft.diorite_stairs": "staighre dióiríte",
  "block.minecraft.polished_granite_slab": "leac eibhir shnasta",
  "block.minecraft.smooth_red_sandstone_slab": "leac ghaineamhchloiche deirge míne",
  "block.minecraft.mossy_stone_brick_slab": "leac bhrící cloiche caonaigh",
  "block.minecraft.polished_diorite_slab": "leac dióiríte snasta",
  "block.minecraft.mossy_cobblestone_slab": "leac dhoirneoige caonaigh",
  "block.minecraft.end_stone_brick_slab": "leac bhrící cloiche an deiridh",
  "block.minecraft.smooth_sandstone_slab": "leac ghaineamhchloiche míne",
  "block.minecraft.smooth_quartz_slab": "leac ghrianchloiche míne",
  "block.minecraft.granite_slab": "leac eibhir",
  "block.minecraft.andesite_slab": "leac aindéisíte",
  "block.minecraft.red_nether_brick_slab": "leac brící dearga ifrinn",
  "block.minecraft.polished_andesite_slab": "leac aindéisíte snasta",
  "block.minecraft.diorite_slab": "leac dhióiríte",
  "block.minecraft.scaffolding": "scafall",
  "block.minecraft.iron_door": "doras iarainn",
  "block.minecraft.oak_door": "doras darach",
  "block.minecraft.spruce_door": "doras sprúis",
  "block.minecraft.birch_door": "doras beithe",
  "block.minecraft.jungle_door": "doras dufaire",
  "block.minecraft.acacia_door": "doras acaicia",
  "block.minecraft.dark_oak_door": "doras darach duibhe",
  "block.minecraft.crimson_door": "doras craorag",
  "block.minecraft.warped_door": "doras saofa",
  "block.minecraft.repeater": "athsheoltóir deargchloiche",
  "block.minecraft.comparator": "comparadóir deargchloiche",
  "block.minecraft.structure_block": "bloc struchtúir",
  "block.minecraft.jigsaw": "bloc mireanna mearaí",
  "item.minecraft.turtle_helmet": "blaosc thurtair□□nuair a bheidh sé ar cheann:□+2 cathéide",
  "item.minecraft.scute": "scút",
  "item.minecraft.iron_shovel": "sluasaid iarainn□□nuair a bheidh sé sa phríomh-lámh:□+3.5 damáiste ionsaithe□-3 luas ionsaithe",
  "item.minecraft.iron_pickaxe": "piocóid iarainn□□nuair a bheidh sé sa phríomh-lámh:□+3 damáiste ionsaithe□-2.8 luas ionsaithe",
  "item.minecraft.iron_axe": "tua iarainn□□nuair a bheidh sé sa phríomh-lámh:□+8 damáiste ionsaithe□-3.1 luas ionsaithe",
  "item.minecraft.flint_and_steel": "breochloch is cruach",
  "item.minecraft.apple": "úll",
  "item.minecraft.bow": "bogha",
  "item.minecraft.arrow": "saighead",
  "item.minecraft.coal": "gual",
  "item.minecraft.charcoal": "gualach",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "tinne iarainn",
  "item.minecraft.gold_ingot": "tinne óir",
  "item.minecraft.netherite_ingot": "tinne íochtairíte",
  "item.minecraft.netherite_scrap": "dramh íochtairíte",
  "item.minecraft.iron_sword": "claíomh iarainn□□nuair a bheidh sé sa phríomh-lámh:□+5 damáiste ionsaithe□-2.4 luas ionsaithe",
  "item.minecraft.wooden_sword": "claíomh adhmaid□□nuair a bheidh sé sa phríomh-lámh:□+3 damáiste ionsaithe□-2.4 luas ionsaithe",
  "item.minecraft.wooden_shovel": "sluasaid adhmaid□□nuair a bheidh sé sa phríomh-lámh:□+1.5 damáiste ionsaithe□-3 luas ionsaithe",
  "item.minecraft.wooden_pickaxe": "piocóid adhmaid□□nuair a bheidh sé sa phríomh-lámh:□+1 damáiste ionsaithe□-2.8 luas ionsaithe",
  "item.minecraft.wooden_axe": "tua adhmaid□□nuair a bheidh sé sa phríomh-lámh:□+6 damáiste ionsaithe□-3.2 luas ionsaithe",
  "item.minecraft.stone_sword": "claíomh cloiche□□nuair a bheidh sé sa phríomh-lámh:□+4 damáiste ionsaithe□-2.4 luas ionsaithe",
  "item.minecraft.stone_shovel": "sluasaid chloiche□□nuair a bheidh sé sa phríomh-lámh:□+2.5 damáiste ionsaithe□-3 luas ionsaithe",
  "item.minecraft.stone_pickaxe": "piocóid chloiche□□nuair a bheidh sé sa phríomh-lámh:□+2 damáiste ionsaithe□-2.8 luas ionsaithe",
  "item.minecraft.stone_axe": "tua chloiche□□nuair a bheidh sé sa phríomh-lámh:□+8 damáiste ionsaithe□-3.2 luas ionsaithe",
  "item.minecraft.diamond_sword": "claíomh diamaint□□nuair a bheidh sé sa phríomh-lámh:□+6 damáiste ionsaithe□-2.4 luas ionsaithe",
  "item.minecraft.diamond_shovel": "sluasaid diamaint□□nuair a bheidh sé sa phríomh-lámh:□+4.5 damáiste ionsaithe□-3 luas ionsaithe",
  "item.minecraft.diamond_pickaxe": "piocóid diamaint□□nuair a bheidh sé sa phríomh-lámh:□+4 damáiste ionsaithe□-2.8 luas ionsaithe",
  "item.minecraft.diamond_axe": "tua dhiamaint□□nuair a bheidh sé sa phríomh-lámh:□+8 damáiste ionsaithe□-3 luas ionsaithe",
  "item.minecraft.stick": "maide",
  "item.minecraft.bowl": "babhla",
  "item.minecraft.mushroom_stew": "stobhach muisiriún",
  "item.minecraft.golden_sword": "claíomh óir□□nuair a bheidh sé sa phríomh-lámh:□+3 damáiste ionsaithe□-2.4 luas ionsaithe",
  "item.minecraft.golden_shovel": "sluasaid óir□□nuair a bheidh sé sa phríomh-lámh:□+1.5 damáiste ionsaithe□-3 luas ionsaithe",
  "item.minecraft.golden_pickaxe": "piocóid óir□□nuair a bheidh sé sa phríomh-lámh:□+1 damáiste ionsaithe□-2.8 luas ionsaithe",
  "item.minecraft.golden_axe": "tua óir□□nuair a bheidh sé sa phríomh-lámh:□+6 damáiste ionsaithe□-3 luas ionsaithe",
  "item.minecraft.netherite_sword": "claíomh íochtairíte□□nuair a bheidh sé sa phríomh-lámh:□+7 damáiste ionsaithe□-2.4 luas ionsaithe",
  "item.minecraft.netherite_shovel": "sluasaid íochtairíte□□nuair a bheidh sé sa phríomh-lámh:□+5.5 damáiste ionsaithe□-3 luas ionsaithe",
  "item.minecraft.netherite_pickaxe": "piocóid íochtairíte□□nuair a bheidh sé sa phríomh-lámh:□+5 damáiste ionsaithe□-2.8 luas ionsaithe",
  "item.minecraft.netherite_axe": "tua íochtairíte□□nuair a bheidh sé sa phríomh-lámh:□+9 damáiste ionsaithe□-3 luas ionsaithe",
  "item.minecraft.string": "sreangán",
  "item.minecraft.feather": "cleite",
  "item.minecraft.gunpowder": "púdar gunna",
  "item.minecraft.wooden_hoe": "grafóg adhmaid□□nuair a bheidh sé sa phríomh-lámh:□-3 luas ionsaithe",
  "item.minecraft.stone_hoe": "grafóg chloiche□□nuair a bheidh sé sa phríomh-lámh:□-2 luas ionsaithe",
  "item.minecraft.iron_hoe": "grafóg iarainn□□nuair a bheidh sé sa phríomh-lámh:□-1 luas ionsaithe",
  "item.minecraft.diamond_hoe": "grafóg dhiamaint□□nuair a bheidh sé sa phríomh-lámh:",
  "item.minecraft.golden_hoe": "grafóg óir□□nuair a bheidh sé sa phríomh-lámh:□-3 luas ionsaithe",
  "item.minecraft.netherite_hoe": "grafóg íochtairíte□□nuair a bheidh sé sa phríomh-lámh:",
  "item.minecraft.wheat_seeds": "síolta gráin",
  "item.minecraft.wheat": "cruithneacht",
  "item.minecraft.bread": "arán",
  "item.minecraft.leather_helmet": "caipín leathair□□nuair a bheidh sé ar cheann:□+1 cathéide",
  "item.minecraft.leather_chestplate": "ionar leathair□□nuair a bheidh tú ar chorp:□+3 cathéide",
  "item.minecraft.leather_leggings": "bríste leathair□□aithe a duit tú ar chosa:□+2 cathéide",
  "item.minecraft.leather_boots": "bróga leathair□□nuair a bheidh tú ar chosa:□+1 cathéide",
  "item.minecraft.chainmail_helmet": "clogad máille□□nuair a bheidh sé ar cheann:□+2 cathéide",
  "item.minecraft.chainmail_chestplate": "lúireach mháille□□nuair a bheidh tú ar chorp:□+5 cathéide",
  "item.minecraft.chainmail_leggings": "loirgneáin mháille□□aithe a duit tú ar chosa:□+4 cathéide",
  "item.minecraft.chainmail_boots": "bróga máille□□nuair a bheidh tú ar chosa:□+1 cathéide",
  "item.minecraft.iron_helmet": "clogad iarainn□□nuair a bheidh sé ar cheann:□+2 cathéide",
  "item.minecraft.iron_chestplate": "uchtach iarainn□□nuair a bheidh tú ar chorp:□+6 cathéide",
  "item.minecraft.iron_leggings": "loirgneáin iarainn□□aithe a duit tú ar chosa:□+5 cathéide",
  "item.minecraft.iron_boots": "bróga iarainn□□nuair a bheidh tú ar chosa:□+2 cathéide",
  "item.minecraft.diamond_helmet": "clogad diamaint□□nuair a bheidh sé ar cheann:□+3 cathéide□+2 righneas cathéide",
  "item.minecraft.diamond_chestplate": "uchtach diamaint□□nuair a bheidh tú ar chorp:□+8 cathéide□+2 righneas cathéide",
  "item.minecraft.diamond_leggings": "loirgneáin diamaint□□aithe a duit tú ar chosa:□+6 cathéide□+2 righneas cathéide",
  "item.minecraft.diamond_boots": "bróga diamaint□□nuair a bheidh tú ar chosa:□+3 cathéide□+2 righneas cathéide",
  "item.minecraft.golden_helmet": "clogad óir□□nuair a bheidh sé ar cheann:□+2 cathéide",
  "item.minecraft.golden_chestplate": "uchtach óir□□nuair a bheidh tú ar chorp:□+5 cathéide",
  "item.minecraft.golden_leggings": "loirgneáin óir□□aithe a duit tú ar chosa:□+3 cathéide",
  "item.minecraft.golden_boots": "bróga óir□□nuair a bheidh tú ar chosa:□+1 cathéide",
  "item.minecraft.netherite_helmet": "clogad íochtairíte□□nuair a bheidh sé ar cheann:□+3 cathéide□+3 righneas cathéide□+1 seasmhacht in aghaidh cnag siar",
  "item.minecraft.netherite_chestplate": "lúireach íochtairíte□□nuair a bheidh tú ar chorp:□+8 cathéide□+3 righneas cathéide□+1 seasmhacht in aghaidh cnag siar",
  "item.minecraft.netherite_leggings": "loirgneáin íochtairíte□□aithe a duit tú ar chosa:□+6 cathéide□+3 righneas cathéide□+1 seasmhacht in aghaidh cnag siar",
  "item.minecraft.netherite_boots": "bróga íochtairíte□□nuair a bheidh tú ar chosa:□+3 cathéide□+3 righneas cathéide□+1 seasmhacht in aghaidh cnag siar",
  "item.minecraft.flint": "breochloch",
  "item.minecraft.porkchop": "gríscín muiceola amh",
  "item.minecraft.cooked_porkchop": "gríscín muiceola cócaráilte",
  "item.minecraft.painting": "pictiúr",
  "item.minecraft.golden_apple": "úll óir",
  "item.minecraft.enchanted_golden_apple": "úll óir draíochta",
  "block.minecraft.oak_sign": "comhartha darach",
  "block.minecraft.spruce_sign": "comhartha sprúis",
  "block.minecraft.birch_sign": "comhartha beithe",
  "block.minecraft.jungle_sign": "comhartha dufaire",
  "block.minecraft.acacia_sign": "comhartha acáise",
  "block.minecraft.dark_oak_sign": "comhartha darach duibhe",
  "block.minecraft.crimson_sign": "comhartha craorag",
  "block.minecraft.warped_sign": "comhartha saofa",
  "item.minecraft.bucket": "buicéad",
  "item.minecraft.water_bucket": "buicéad uisce",
  "item.minecraft.lava_bucket": "buicéad laibhe",
  "item.minecraft.minecart": "cairt mianaigh",
  "item.minecraft.saddle": "diallait",
  "item.minecraft.redstone": "deannach deargchloiche",
  "item.minecraft.snowball": "meall sneachta",
  "item.minecraft.oak_boat": "bád darach",
  "item.minecraft.leather": "leathar",
  "item.minecraft.milk_bucket": "síothal bainne",
  "item.minecraft.pufferfish_bucket": "síothal iasc bolgach",
  "item.minecraft.salmon_bucket": "síothal bradáin",
  "item.minecraft.cod_bucket": "buicéad troisc",
  "item.minecraft.tropical_fish_bucket": "síothal iasc trópaiceach",
  "item.minecraft.brick": "bríce",
  "item.minecraft.clay_ball": "meall cré",
  "block.minecraft.dried_kelp_block": "bloc sicheilpe",
  "item.minecraft.paper": "páipéar",
  "item.minecraft.book": "leabhar",
  "item.minecraft.slime_ball": "cnapán glae",
  "item.minecraft.chest_minecart": "cairt mianaigh le cófra",
  "item.minecraft.furnace_minecart": "cairt mianaigh le foirnéis",
  "item.minecraft.egg": "ubh",
  "item.minecraft.compass": "compás",
  "item.minecraft.fishing_rod": "slat iascaigh",
  "item.minecraft.clock": "clog",
  "item.minecraft.glowstone_dust": "deannach lonnraíte",
  "item.minecraft.cod": "trosc amh",
  "item.minecraft.salmon": "grísc bhradáin",
  "item.minecraft.tropical_fish": "iasc trópaiceach",
  "item.minecraft.pufferfish": "iasc bolgach",
  "item.minecraft.cooked_cod": "trosc cócaráilte",
  "item.minecraft.cooked_salmon": "bradán friochta",
  "item.minecraft.ink_sac": "sac dúigh",
  "item.minecraft.red_dye": "ruaim dhearg",
  "item.minecraft.green_dye": "ruaim uaine",
  "item.minecraft.cocoa_beans": "pónairí cacó",
  "item.minecraft.lapis_lazuli": "lapis lazuli",
  "item.minecraft.purple_dye": "ruaim chorcra",
  "item.minecraft.cyan_dye": "ruaim chian",
  "item.minecraft.light_gray_dye": "ruaim fhionnliath",
  "item.minecraft.gray_dye": "ruaim liath",
  "item.minecraft.pink_dye": "ruaim bhándearg",
  "item.minecraft.lime_dye": "ruaim líomach",
  "item.minecraft.yellow_dye": "ruaim bhuí",
  "item.minecraft.light_blue_dye": "ruaim bhánghorm",
  "item.minecraft.magenta_dye": "ruaim mhaigeanta",
  "item.minecraft.orange_dye": "ruaim oráisteach",
  "item.minecraft.bone_meal": "min chnámh",
  "item.minecraft.blue_dye": "ruaim ghorm",
  "item.minecraft.brown_dye": "ruaim dhonn",
  "item.minecraft.black_dye": "ruaim dhubh",
  "item.minecraft.white_dye": "ruaim bhán",
  "item.minecraft.bone": "cnámh",
  "item.minecraft.sugar": "siúcra",
  "block.minecraft.cake": "cáca",
  "block.minecraft.white_bed": "leaba bhán",
  "block.minecraft.orange_bed": "leaba oráisteach",
  "block.minecraft.magenta_bed": "leaba mhaigeanta",
  "block.minecraft.light_blue_bed": "leaba bhánghorm",
  "block.minecraft.yellow_bed": "leaba bhuí",
  "block.minecraft.lime_bed": "leaba líomach",
  "block.minecraft.pink_bed": "leaba bhándearg",
  "block.minecraft.gray_bed": "leaba liath",
  "block.minecraft.light_gray_bed": "leaba fhionnliath",
  "block.minecraft.cyan_bed": "leaba chian",
  "block.minecraft.purple_bed": "leaba chorcra",
  "block.minecraft.blue_bed": "leaba ghorm",
  "block.minecraft.brown_bed": "leaba dhonn",
  "block.minecraft.green_bed": "leaba uaine",
  "block.minecraft.red_bed": "leaba dhearg",
  "block.minecraft.black_bed": "leaba dhubh",
  "item.minecraft.cookie": "briosca",
  "item.minecraft.filled_map": "léarscáil□#0",
  "item.minecraft.shears": "deimheas",
  "item.minecraft.melon_slice": "píosa mealbhacán",
  "item.minecraft.dried_kelp": "sicheilp",
  "item.minecraft.pumpkin_seeds": "síolta puimcín",
  "item.minecraft.melon_seeds": "síolta mealbhacáin",
  "item.minecraft.beef": "mairteoil amh",
  "item.minecraft.cooked_beef": "stéig",
  "item.minecraft.chicken": "sicín amh",
  "item.minecraft.cooked_chicken": "sicín cócaráilte",
  "item.minecraft.rotten_flesh": "feoil lofa",
  "item.minecraft.ender_pearl": "péarla na críche",
  "item.minecraft.blaze_rod": "slat lasaire",
  "item.minecraft.ghast_tear": "deoir an uafairigh",
  "item.minecraft.gold_nugget": "cnap óir",
  "item.minecraft.nether_wart": "mus an íochtair",
  "item.minecraft.potion": "posóid dochumtha□gan éifeacht i bhfeidhm",
  "item.minecraft.glass_bottle": "buidéal gloine",
  "item.minecraft.spider_eye": "súil damháin alla",
  "item.minecraft.fermented_spider_eye": "súil damháin alla coipthe",
  "item.minecraft.blaze_powder": "púdar lasaire",
  "item.minecraft.magma_cream": "uachtar magma",
  "block.minecraft.brewing_stand": "seastán grúdaireachta",
  "block.minecraft.cauldron": "coire",
  "item.minecraft.ender_eye": "súil na críche",
  "item.minecraft.glistering_melon_slice": "píosa mealbhacán gleorach",
  "item.minecraft.bat_spawn_egg": "ubh giniúint ialtóg",
  "item.minecraft.bee_spawn_egg": "ubh giniúint beacha",
  "item.minecraft.blaze_spawn_egg": "ubh giniúint lasairí",
  "item.minecraft.cat_spawn_egg": "ubh giniúint cat",
  "item.minecraft.cave_spider_spawn_egg": "ubh giniúint damhán alla uaimhe",
  "item.minecraft.chicken_spawn_egg": "ubh giniúint sicíní",
  "item.minecraft.cod_spawn_egg": "ubh giniúint trosc",
  "item.minecraft.cow_spawn_egg": "ubh giniúint bó",
  "item.minecraft.creeper_spawn_egg": "ubh giniúint téaltóirí",
  "item.minecraft.dolphin_spawn_egg": "ubh giniúint deilfeanna",
  "item.minecraft.donkey_spawn_egg": "ubh giniúint asal",
  "item.minecraft.drowned_spawn_egg": "ubh giniúint báiteachán",
  "item.minecraft.elder_guardian_spawn_egg": "ubh giniúint coimeádaithe sinsearacha",
  "item.minecraft.enderman_spawn_egg": "ubh giniúint críochnaitheoirí",
  "item.minecraft.endermite_spawn_egg": "ubh giniúint frídí na críche",
  "item.minecraft.evoker_spawn_egg": "ubh giniúint gairmneachán",
  "item.minecraft.fox_spawn_egg": "ubh giniúint sionnach",
  "item.minecraft.ghast_spawn_egg": "ubh giniúint uafaireach",
  "item.minecraft.guardian_spawn_egg": "ubh giniúint coimeádaithe",
  "item.minecraft.hoglin_spawn_egg": "ubh giniúint borrachán",
  "item.minecraft.horse_spawn_egg": "ubh ghinte capall",
  "item.minecraft.husk_spawn_egg": "ubh giniúint seargán",
  "item.minecraft.llama_spawn_egg": "ubh giniúint lámaí",
  "item.minecraft.magma_cube_spawn_egg": "ubh giniúint ciúbanna magma",
  "item.minecraft.mooshroom_spawn_egg": "ubh giniúint bócán",
  "item.minecraft.mule_spawn_egg": "ubh giniúint miúileanna",
  "item.minecraft.ocelot_spawn_egg": "ubh giniúint osalat",
  "item.minecraft.panda_spawn_egg": "ubh giniúint pandaí",
  "item.minecraft.parrot_spawn_egg": "ubh giniúint pearóidí",
  "item.minecraft.phantom_spawn_egg": "ubh giniúint púcaí",
  "item.minecraft.pig_spawn_egg": "ubh giniúint muc",
  "item.minecraft.piglin_spawn_egg": "ubh giniúint mucán",
  "item.minecraft.pillager_spawn_egg": "ubh giniúint creachadán",
  "item.minecraft.polar_bear_spawn_egg": "ubh giniúint béar bán",
  "item.minecraft.pufferfish_spawn_egg": "ubh giniúint iasc bolgach",
  "item.minecraft.rabbit_spawn_egg": "ubh giniúint coiníní",
  "item.minecraft.ravager_spawn_egg": "ubh giniúint sladairí",
  "item.minecraft.salmon_spawn_egg": "ubh giniúint bradán",
  "item.minecraft.sheep_spawn_egg": "ubh giniúint caorach",
  "item.minecraft.shulker_spawn_egg": "ubh giniúint mollcairí",
  "item.minecraft.silverfish_spawn_egg": "ubh giniúint gilíní",
  "item.minecraft.skeleton_spawn_egg": "ubh giniúint cnámharlach",
  "item.minecraft.skeleton_horse_spawn_egg": "ubh giniúint capall cnámharlaigh",
  "item.minecraft.slime_spawn_egg": "ubh giniúint ramallóg",
  "item.minecraft.spider_spawn_egg": "ubh giniúint damhán alla",
  "item.minecraft.squid_spawn_egg": "ubh giniúint scuideanna",
  "item.minecraft.stray_spawn_egg": "ubh giniúint fánaithe",
  "item.minecraft.strider_spawn_egg": "ubh giniúint truslógaithe",
  "item.minecraft.trader_llama_spawn_egg": "ubh giniúint láma an trádálaí",
  "item.minecraft.tropical_fish_spawn_egg": "ubh giniúint iasc trópaiceach",
  "item.minecraft.turtle_spawn_egg": "ubh giniúint turtar",
  "item.minecraft.vex_spawn_egg": "ubh giniúint buairteoir",
  "item.minecraft.villager_spawn_egg": "ubh giniúint sráideánach",
  "item.minecraft.vindicator_spawn_egg": "ubh giniúint dlisteanóirí",
  "item.minecraft.wandering_trader_spawn_egg": "ubh giniúint trádálaí fánach",
  "item.minecraft.witch_spawn_egg": "ubh giniúint cailleach",
  "item.minecraft.wither_skeleton_spawn_egg": "ubh giniúint cnámharlach seargthóra",
  "item.minecraft.wolf_spawn_egg": "ubh giniúint mac tíre",
  "item.minecraft.zoglin_spawn_egg": "ubh giniúint zorrachán",
  "item.minecraft.zombie_spawn_egg": "ubh giniúint zombaithe",
  "item.minecraft.zombie_horse_spawn_egg": "ubh giniúint capall zombaí",
  "item.minecraft.zombie_villager_spawn_egg": "ubh giniúint sráideánach zombaí",
  "item.minecraft.zombified_piglin_spawn_egg": "ubh giniúint mucán zombáilte",
  "item.minecraft.experience_bottle": "buidéal asarlaíochta",
  "item.minecraft.fire_charge": "lánán tine",
  "item.minecraft.writable_book": "leabhar agus peann cleite",
  "item.minecraft.written_book": "leabhar scríofa",
  "item.minecraft.emerald": "smaragaid",
  "item.minecraft.item_frame": "fráma earra",
  "block.minecraft.flower_pot": "pota bláthanna",
  "item.minecraft.carrot": "cairéad",
  "item.minecraft.potato": "práta",
  "item.minecraft.baked_potato": "práta bácáilte",
  "item.minecraft.poisonous_potato": "práta nimhiúil",
  "item.minecraft.map": "léarscáil bhán",
  "item.minecraft.golden_carrot": "cairéad óir",
  "block.minecraft.skeleton_skull": "cloigeann cnámharlaigh",
  "block.minecraft.wither_skeleton_skull": "cloigeann cnámharlaigh shirg",
  "block.minecraft.player_head": "ceann imreora",
  "block.minecraft.zombie_head": "ceann zombaí",
  "block.minecraft.creeper_head": "ceann téaltóra",
  "block.minecraft.dragon_head": "ceann dragain",
  "item.minecraft.carrot_on_a_stick": "meacan dearg ar maide",
  "item.minecraft.warped_fungus_on_a_stick": "fungas saofa ar maide",
  "item.minecraft.nether_star": "réalta an íochtair",
  "item.minecraft.pumpkin_pie": "pióg phuimcín",
  "item.minecraft.firework_rocket": "roicéad tine ealaíne",
  "item.minecraft.firework_star": "réalta bladhmainn",
  "item.minecraft.enchanted_book": "leabhar draíochta",
  "item.minecraft.nether_brick": "bloc íochtarbhrící",
  "item.minecraft.quartz": "grianchloch an íochtair",
  "item.minecraft.tnt_minecart": "cairt le tnt",
  "item.minecraft.hopper_minecart": "cairt le crannóg",
  "item.minecraft.prismarine_shard": "scealp phriosmuirínigh",
  "item.minecraft.prismarine_crystals": "criostail phriosmuirínigh",
  "item.minecraft.rabbit": "coinín amh",
  "item.minecraft.cooked_rabbit": "coinín cócaráilte",
  "item.minecraft.rabbit_stew": "stobhach coinín",
  "item.minecraft.rabbit_foot": "cos coinín",
  "item.minecraft.rabbit_hide": "craiceann coinín",
  "item.minecraft.armor_stand": "seastán cathéide",
  "item.minecraft.iron_horse_armor": "cathéide iarainn do chapall",
  "item.minecraft.golden_horse_armor": "cathéide óir do chapall",
  "item.minecraft.diamond_horse_armor": "cathéide dhiamaint do chapall",
  "item.minecraft.leather_horse_armor": "cathéide leathair do chapall",
  "item.minecraft.lead": "iall",
  "item.minecraft.name_tag": "lipéad ainm",
  "item.minecraft.command_block_minecart": "cairt le bloc ordaithe",
  "item.minecraft.mutton": "caoireoil amh",
  "item.minecraft.cooked_mutton": "caoireoil cócaráilte",
  "block.minecraft.white_banner": "meirge bán",
  "block.minecraft.orange_banner": "meirge oráisteach",
  "block.minecraft.magenta_banner": "meirge maigeanta",
  "block.minecraft.light_blue_banner": "meirge bánghorm",
  "block.minecraft.yellow_banner": "meirge buí",
  "block.minecraft.lime_banner": "meirge líomach",
  "block.minecraft.pink_banner": "meirge bándearg",
  "block.minecraft.gray_banner": "meirge liath",
  "block.minecraft.light_gray_banner": "meirge fionnliath",
  "block.minecraft.cyan_banner": "meirge cian",
  "block.minecraft.purple_banner": "meirge corcra",
  "block.minecraft.blue_banner": "meirge gorm",
  "block.minecraft.brown_banner": "meirge donn",
  "block.minecraft.green_banner": "meirge uaine",
  "block.minecraft.red_banner": "meirge dearg",
  "block.minecraft.black_banner": "meirge dubh",
  "item.minecraft.end_crystal": "criostal na críche",
  "item.minecraft.chorus_fruit": "toradh chorus",
  "item.minecraft.popped_chorus_fruit": "toradh chorus rósta",
  "item.minecraft.beetroot": "biatas",
  "item.minecraft.beetroot_seeds": "síol biatais",
  "item.minecraft.beetroot_soup": "anraith biatas",
  "item.minecraft.dragon_breath": "anáil dragain",
  "item.minecraft.splash_potion": "posóid theilgeach dochumtha□gan éifeacht i bhfeidhm",
  "item.minecraft.spectral_arrow": "saighead síofrúil",
  "item.minecraft.tipped_arrow": "saighead biorach dochumtha□gan éifeacht i bhfeidhm",
  "item.minecraft.lingering_potion": "posóid righin dochumtha□gan éifeacht i bhfeidhm",
  "item.minecraft.shield": "sciath",
  "item.minecraft.elytra": "eilitreaim",
  "item.minecraft.spruce_boat": "bád sprúis",
  "item.minecraft.birch_boat": "bád beithe",
  "item.minecraft.jungle_boat": "bád dufaire",
  "item.minecraft.acacia_boat": "bád acaicia",
  "item.minecraft.dark_oak_boat": "bád darach duibhe",
  "item.minecraft.totem_of_undying": "tótam na síoraíochta",
  "item.minecraft.shulker_shell": "blaosc mhollcaire",
  "item.minecraft.iron_nugget": "cnap iarainn",
  "item.minecraft.knowledge_book": "leabhar eolais",
  "item.minecraft.debug_stick": "baitín dífhabhtaithe",
  "item.minecraft.music_disc_13": "diosca ceoil□c418 - 13",
  "item.minecraft.music_disc_cat": "diosca ceoil□c418 - cat",
  "item.minecraft.music_disc_blocks": "diosca ceoil□c418 - blocks",
  "item.minecraft.music_disc_chirp": "diosca ceoil□c418 - chirp",
  "item.minecraft.music_disc_far": "diosca ceoil□c418 - far",
  "item.minecraft.music_disc_mall": "diosca ceoil□c418 - mall",
  "item.minecraft.music_disc_mellohi": "diosca ceoil□c418 - mellohi",
  "item.minecraft.music_disc_stal": "diosca ceoil□c418 - stal",
  "item.minecraft.music_disc_strad": "diosca ceoil□c418 - strad",
  "item.minecraft.music_disc_ward": "diosca ceoil□c418 - ward",
  "item.minecraft.music_disc_11": "diosca ceoil□c418 - 11",
  "item.minecraft.music_disc_wait": "diosca ceoil□c418 - wait",
  "item.minecraft.music_disc_pigstep": "diosca ceoil□lena raine - pigstep",
  "item.minecraft.trident": "trírinn□□nuair a bheidh sé sa phríomh-lámh:□+8 damáiste ionsaithe□-2.9 luas ionsaithe",
  "item.minecraft.phantom_membrane": "seicin púca",
  "item.minecraft.nautilus_shell": "blaosc nátalais",
  "item.minecraft.heart_of_the_sea": "croí na mara",
  "item.minecraft.crossbow": "crosbhogha",
  "item.minecraft.suspicious_stew": "stobhach amhrasach",
  "block.minecraft.loom": "seol",
  "item.minecraft.flower_banner_pattern": "patrún brataí□bláth",
  "item.minecraft.creeper_banner_pattern": "patrún brataí□lánán creeper",
  "item.minecraft.skull_banner_pattern": "patrún brataí□lánán cloiginn",
  "item.minecraft.mojang_banner_pattern": "patrún brataí□dada",
  "item.minecraft.globe_banner_pattern": "patrún brataí□cruinne",
  "item.minecraft.piglin_banner_pattern": "patrún meirge□soc",
  "block.minecraft.composter": "múiríneoir",
  "block.minecraft.barrel": "bairille",
  "block.minecraft.smoker": "leasóir",
  "block.minecraft.blast_furnace": "foirnéis soinneáin",
  "block.minecraft.cartography_table": "bord cartagrafaíochta",
  "block.minecraft.fletching_table": "bord saighde",
  "block.minecraft.grindstone": "cloch fhaobhair",
  "block.minecraft.lectern": "léachtán",
  "block.minecraft.smithing_table": "bord gabha",
  "block.minecraft.stonecutter": "gearrthóir cloiche",
  "block.minecraft.bell": "clog",
  "block.minecraft.lantern": "laindéar",
  "block.minecraft.soul_lantern": "laindéar spride",
  "item.minecraft.sweet_berries": "caora milse",
  "block.minecraft.campfire": "tine champa",
  "block.minecraft.soul_campfire": "tine champa spride",
  "block.minecraft.shroomlight": "breocán",
  "item.minecraft.honeycomb": "milteog",
  "block.minecraft.bee_nest": "nead bheiche",
  "block.minecraft.beehive": "coirceog",
  "item.minecraft.honey_bottle": "buidéal meala",
  "block.minecraft.honey_block": "bloc meala",
  "block.minecraft.honeycomb_block": "bloc milteoige",
  "block.minecraft.lodestone": "adhmaint",
  "block.minecraft.netherite_block": "bloc íochtairíte",
  "block.minecraft.ancient_debris": "mionbhach ársa",
  "block.minecraft.target": "sprioc",
  "block.minecraft.crying_obsidian": "obsaidian marmarach",
  "block.minecraft.blackstone": "dúchloch",
  "block.minecraft.blackstone_slab": "leac dhúchloiche",
  "block.minecraft.blackstone_stairs": "staighre dúchloiche",
  "block.minecraft.gilded_blackstone": "dúchloch óraithe",
  "block.minecraft.polished_blackstone": "dúchloch shnasta",
  "block.minecraft.polished_blackstone_slab": "leac dhúchloiche snasta",
  "block.minecraft.polished_blackstone_stairs": "staighre dúchloiche snasta",
  "block.minecraft.chiseled_polished_blackstone": "dúchloch shnasta shiséalta",
  "block.minecraft.polished_blackstone_bricks": "brící dúchloiche snasta",
  "block.minecraft.polished_blackstone_brick_slab": "leac de bhrící dúchloiche snasta",
  "block.minecraft.polished_blackstone_brick_stairs": "staighre de bhrící dúchloiche snasta",
  "block.minecraft.cracked_polished_blackstone_bricks": "brící dúchloiche snasta siséalta",
  "block.minecraft.respawn_anchor": "ancaire sceith",
}
export const ga_ie = items; 
